// src/pages/Wallet/hooks/useModalState.js
import { useState } from 'react';

/**
 * Hook to manage the state of multiple modals in the wallet interface
 * Provides functions to open/close different modals
 */
export const useModalState = () => {
  const [showNetworkModal, setShowNetworkModal] = useState(false);
  const [showWalletModal, setShowWalletModal] = useState(false);
  const [showSendModal, setShowSendModal] = useState(false);
  const [showSendNFTModal, setShowSendNFTModal] = useState(false); // NEW: Added SendNFTModal state
  const [showReceiveModal, setShowReceiveModal] = useState(false);
  const [showTokenManagementModal, setShowTokenManagementModal] = useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  // Open/close network modal
  const toggleNetworkModal = (isOpen = !showNetworkModal) => {
    setShowNetworkModal(isOpen);
  };

  // Open/close wallet selector modal
  const toggleWalletModal = (isOpen = !showWalletModal) => {
    setShowWalletModal(isOpen);
  };

  // Open/close send token modal
  const toggleSendModal = (isOpen = !showSendModal) => {
    setShowSendModal(isOpen);
  };

  // NEW: Open/close send NFT modal
  const toggleSendNFTModal = (isOpen = !showSendNFTModal) => {
    setShowSendNFTModal(isOpen);
  };

  // Open/close receive modal
  const toggleReceiveModal = (isOpen = !showReceiveModal) => {
    setShowReceiveModal(isOpen);
  };

  // Open/close token management modal
  const toggleTokenManagementModal = (isOpen = !showTokenManagementModal) => {
    setShowTokenManagementModal(isOpen);
  };

  // Open/close transaction confirmation modal
  const toggleConfirmationModal = (isOpen = !isConfirmationModalOpen) => {
    setIsConfirmationModalOpen(isOpen);
  };

  return {
    showNetworkModal,
    showWalletModal,
    showSendModal,
    showSendNFTModal, // NEW: Export SendNFTModal state
    showReceiveModal,
    showTokenManagementModal,
    isConfirmationModalOpen,
    toggleNetworkModal,
    toggleWalletModal,
    toggleSendModal,
    toggleSendNFTModal, // NEW: Export SendNFTModal toggle function
    toggleReceiveModal,
    toggleTokenManagementModal,
    toggleConfirmationModal
  };
};